(function() {
  if (window.fjOpenMonthlyBoxQuickBuyDrawer) return;

  window.fjOpenMonthlyBoxQuickBuyDrawer = function(productId, drawerIdHint) {
    var pid = productId != null && productId !== '' ? String(productId) : '';
    var drawer = null;

    if (drawerIdHint && typeof drawerIdHint === 'string') {
      drawer = document.getElementById(drawerIdHint);
    }

    if (!drawer && pid) {
      drawer = document.querySelector(
        '[id*="monthly-box-"][id$="-' + pid + '-drawer"]'
      );
    }

    if (!drawer) {
      drawer = document.querySelector('[id^="monthly-box-"][id$="-drawer"]');
    }

    if (!drawer) {
      var w = document.querySelector('.monthly-box-widget');
      if (w) {
        w.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() {
          var b = w.querySelector('.monthly-box-widget__select-options-button');
          if (b) b.click();
        }, 450);
      }
      return;
    }

    var toggleBtn =
      document.querySelector('.monthly-box-widget [aria-controls="' + drawer.id + '"]') ||
      document.querySelector('[aria-controls="' + drawer.id + '"]');

    function syncToggle() {
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function openDrawerSync() {
      try {
        drawer.setAttribute('open', '');
        syncToggle();
      } catch (err) {
        try {
          if (toggleBtn) {
            toggleBtn.click();
          } else {
            drawer.open = true;
          }
        } catch (e2) {}
      }
    }

    function openDrawerFallback() {
      try {
        if (toggleBtn) {
          toggleBtn.click();
        }
        drawer.open = true;
        syncToggle();
      } catch (err) {}
    }

    openDrawerSync();

    if (window.customElements && typeof customElements.whenDefined === 'function') {
      customElements.whenDefined('quick-buy-drawer').then(function() {
        if (!drawer.hasAttribute('open')) {
          openDrawerSync();
        }
      }).catch(openDrawerFallback);
    }

    setTimeout(function() {
      if (!drawer.hasAttribute('open')) {
        openDrawerSync();
      }
    }, 0);

    setTimeout(function() {
      if (!drawer.hasAttribute('open')) {
        openDrawerFallback();
      }
    }, 300);
  };
})();
